(function() {
    "use strict";

    angular
        .module("laekkerAI.tablet")
        .controller("ToolbarController", [ToolbarController]);

    function ToolbarController() {
        var $ctrl = this;

        $ctrl.$onInit = function() {};

        $ctrl.$onChanges = function(changes) {};

        $ctrl.$onDestroy = function() {};
    }
})();
